export default "__VITE_ASSET__j977bEuy__"